/**
 * 基础请求拼装
 * @param url:[string] 请求地址
 * @param headers:[func] 特殊请求头, 都可选
 */
import axios from 'axios';
import { getSign } from './getSign';
import { urlStringToObj } from './tools';

const defaultOptions = {
  withCredentials: true,
  timeout: 10000,
  headers: {
    'content-type': 'application/json',
  },
};

const serverLog = ({url, postData, respData, sendTime}) => {};

const request = (url, fetchParams) => {
  return axios({url, ...fetchParams});
};

export const get = ({url = '', data = {}, option}) => {
  const sendTime = Date.now();

  let _url = url.split('?')[0];
  let urlparams = {};
  if (url.indexOf('?') > -1) {
    urlparams = urlStringToObj(url.split('?')[1]);
  }
  let _data = {
    ...urlparams,
    ...data,
  }
  let params = getSign(_data);
  return request(_url, {method: 'get', params: params, ...defaultOptions, ...option})
    .then(res => {
      return res.data;
    })
    .then(json => {
      json.isOK = +json.status === 0 || +json.status === 8193 || json.code === 200;
      json.original = {url, data};
      return json;
    })
    .catch(e => {
      serverLog({url, postData: data, respData: e, sendTime});
      if (e.response) {
        throw e.response.data;
      } else {
        throw e;
      }
    });
};

export function post({url = '', data = null, option}) {
  const sendTime = Date.now();
  let _data = getSign(data);
  return request(url, {method: 'post', data: _data, ...defaultOptions, ...option})
    .then(res => {
      // console.info('------------------',res)
      return res.data;
    })
    .then(json => {
      json.isOK = +json.status === 0 || +json.status === 8193 || json.code === 200;
      json.original = {url, data};
      return json;
    })
    .catch(e => {
      serverLog({url, postData: data, respData: e, sendTime});
      if (e.response) {
        throw e.response.data;
      } else {
        throw e;
      }
    });
}

export function jsonp(url, data) {
  if (!url) throw new Error('url is necessary');
  const callback = 'CALLBACK' + Math.random().toString().substr(9, 18);
  const JSONP = document.createElement('script');
  JSONP.setAttribute('type', 'text/javascript');

  const headEle = document.getElementsByTagName('head')[0];

  let ret = '';
  if (data) {
    if (typeof data === 'string') ret = '&' + data;
    else if (typeof data === 'object') {
      for (let key in data) ret += '&' + key + '=' + encodeURIComponent(data[key]);
    }
    ret += '&_time=' + Date.now();
  }
  JSONP.src = `${url}?callback=${callback}${ret}`;
  return new Promise((resolve, reject) => {
    window[callback] = r => {
      resolve(r);
      headEle.removeChild(JSONP);
      delete window[callback];
    };
    headEle.appendChild(JSONP);
  });
}
